{
  "frozen-columns-onboarding.spotlight.body": "Sortieren und blockieren Sie Vorgänge und ändern Sie ihre Größe über ein einziges Steuerelement.",
  "frozen-columns-onboarding.spotlight.dismiss": "OK",
  "frozen-columns-onboarding.spotlight.heading": "Vorgänge verwalten",
  "jira-nin-group-by-any-field-changeboarding.spotlight.body": "Gruppieren Sie Vorgänge nach Feldern, einschließlich Versionen, Stichwörtern, Vorgangstypen und mehr.",
  "jira-nin-group-by-any-field-changeboarding.spotlight.dismiss": "OK",
  "jira-nin-group-by-any-field-changeboarding.spotlight.heading": "Vorgänge gruppieren für mehr Ordnung"
}